import { AnalyticsBrowser } from "@segment/analytics-next";

// Load Segment Analytics Instance
const analyticsInstance = AnalyticsBrowser.load({
  writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
});

// Function to build base/common properties for every event
const buildBaseProperties = () => ({
  platform: "web",
  device: typeof window !== "undefined" ? getDeviceType() : "desktop",
  timestamp: new Date(),
});

// Utility to detect device type
const getDeviceType = () => {
  if (/Mobi|Android/i.test(navigator.userAgent)) return "mobile";
  return "desktop";
};

// Safe Event Tracker Wrapper
const eventTracker = {
  track: (event, customProperties = {}) => {
    try {
      if (analyticsInstance && typeof analyticsInstance.track === "function") {
        const properties = {
          ...buildBaseProperties(),
          ...customProperties,
        };

        console.log(`Tracking Event: ${event}`, properties); // (Optional Debug Log)
        analyticsInstance.track(event, properties);
      } else {
        console.warn(`Analytics not initialized. Skipped event: ${event}`);
      }
    } catch (error) {
      console.error(`Analytics tracking failed for event: ${event}`, error);
    }
  },
};

export default eventTracker;
